/**!
 * Created by Leonardo Cheslacki on 09/05/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import StudentController from './StudentController';

import WithType from './../helpers/WithType';

import config from './../../../../config';

const {default: {routes: {api, web}}} = config;

let _this = {};

/**
 *
 */
class StudentLibrary extends StudentController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            data: {},
            element: null
        };

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         * @param _id
         */
        handleReadFile: function (event, {_id}) {
            const {data} = _this.state;

            let libraries = _this.verifyField(data, 'classroom_student.year.libraries'),
                {attachment: {formatted_path}} = _this.findDataId(libraries, _id);

            _this.downloadFile(formatted_path);
        },

        /**
         *
         * @param event
         * @param _id
         * @param occurrence
         */
        handleReadAudio: function (event, {_id, occurrence}) {
            const {data} = _this.state;

            let libraries = _this.verifyField(data, 'classroom_student.year.libraries'),
                {attachment: {formatted_path}} = _this.findDataId(libraries, _id);

            _this.openAudio(formatted_path, occurrence);
        },

        /**
         *
         * @param event
         * @param element
         * @param occurrence
         */
        handleTimeUpdateAudio: function (event, {element, occurrence}) {
            const
                _this_frame = _this.getFrame(),
                {occ_time, occ_progress: {occ_slide, occ_point}} = _this_frame[`occ_menu_audio_${occurrence}`];

            if (_this.isElement(element, 'audio')) {
                occ_time.text = `${_this.getFormatSecondsToTime(element.currentTime)} / ${_this.getFormatSecondsToTime(element.duration)}`;

                occ_point.setTransform(_this.calcSize(element.duration, element.currentTime, occ_slide.nominalBounds.width), occ_point.y);
            }
        },

        /**
         *
         * @param event
         * @param element
         * @param occurrence
         * @param status
         */
        handlePauseAudio: function (event, {element, occurrence, status}) {
            const _this_frame = _this.getFrame();

            if (_this.isElement(element, 'audio') && ((element.id === occurrence) && !Boolean(status.pause))) {
                _this.gotoAndStopFrame(_this_frame[`occ_menu_audio_${occurrence}`].occ_play, 1);
                status.pause = true;
            }
        },

        /**
         *
         * @param event
         * @param occurrence
         */
        handleMutedAudio: function (event, {occurrence}) {
            const
                {element} = _this.state,
                _this_frame = _this.getFrame();

            if (_this.isElement(element, 'audio') && (element.id === occurrence)) {
                let muted = !Boolean(element.muted);
                _this.gotoAndStopFrame(_this_frame[`occ_menu_audio_${occurrence}`].occ_muted, (muted ? 2 : 1));
                element.muted = muted;
            }
        },

        handleReadVideo: function () {
            _this.openVideo();
        },

        /**
         *
         * @param event
         * @param element
         */
        handleTimeUpdateVideo: function (event, {element}) {
            const
                {occ_menu_video} = _this.getFrame(),
                {occ_time, occ_progress: {occ_slide, occ_point}} = occ_menu_video;

            if (_this.isElement(element, 'video')) {
                occ_time.text = `${_this.getFormatSecondsToTime(element.currentTime)} / ${_this.getFormatSecondsToTime(element.duration)}`;

                occ_point.setTransform(_this.calcSize(element.duration, element.currentTime, occ_slide.nominalBounds.width), occ_point.y);
            }
        },

        /**
         *
         * @param event
         * @param element
         * @param status
         */
        handlePauseVideo: function (event, {element, status}) {
            const {occ_menu_video} = _this.getFrame();

            if (_this.isElement(element, 'video') && !Boolean(status.pause)) {
                _this.gotoAndStopFrame(occ_menu_video.occ_play, 1);
                status.pause = true;
            }
        },

        handleMutedVideo: function () {
            const
                {element} = _this.state,
                _this_frame = _this.getFrame();

            if (_this.isElement(element, 'video')) {
                let muted = !Boolean(element.muted);
                _this.gotoAndStopFrame(_this_frame.occ_menu_video.occ_muted, (muted ? 2 : 1));
                element.muted = muted;
            }
        },

        /**
         *
         * @param event
         * @param thumbnail
         * @param scaleX
         * @param scaleY
         */
        handleFullScreenVideo: function (event, {thumbnail, scaleX, scaleY}) {
            const
                _this_frame = _this.getFrame(),
                {occ_modal, occ_modal: {btn_menu_full}} = _this_frame;

            thumbnail.scaleX = 1;
            thumbnail.scaleY = 1;

            occ_modal.visible = true;

            occ_modal.occ_full_screen.addChild(thumbnail);

            this._handleFullScreenVideoClose && btn_menu_full.off('mousedown', this._handleFullScreenVideoClose);
            this._handleFullScreenVideoClose = btn_menu_full.on('mousedown', _this.$functions.handleFullScreenVideoClose, false, false, {
                thumbnail: thumbnail,
                scaleX: scaleX,
                scaleY: scaleY
            });
        },

        /**
         *
         * @param event
         * @param thumbnail
         * @param scaleX
         * @param scaleY
         */
        handleFullScreenVideoClose: function (event, {thumbnail, scaleX, scaleY}) {
            const
                _this_frame = _this.getFrame(),
                {occ_modal, occ_player} = _this_frame;

            thumbnail.scaleX = scaleX;
            thumbnail.scaleY = scaleY;

            occ_modal.visible = false;

            occ_player.occ_movie.occ_video.addChild(thumbnail);
        }
    };

    /**
     *
     * @param uri
     * @param occurrence
     */
    openAudio = (uri, occurrence) => {
        const
            {element} = this.state,
            _this_frame = this.getFrame(),
            type_timeupdate = 'timeupdate',
            reference_timeupdate = `timeupdate-audio-${occurrence}`,
            type_pause = 'pause',
            reference_pause = `pause-audio-${occurrence}`,
            occ_menu_audio = _this_frame[`occ_menu_audio_${occurrence}`];

        if (this.isElement(element, 'audio')) {
            element.pause();

            let listener = this.getListener(reference_pause);

            if (!this.isEmpty(listener)) {
                const {data: {status}} = listener;

                if ((element.id === occurrence) && Boolean(status.pause)) {
                    this.gotoAndStopFrame(occ_menu_audio.occ_play, 2);
                    status.pause = false;
                    element.play();
                }
            }
        }

        if (!this.isElement(element) || (this.isElement(element, 'audio') && (element.id !== occurrence))) {
            this.setState({...this.state, element: document.createElement('audio')}, ({element}) => {
                this.gotoAndStopFrame(occ_menu_audio.occ_play, 2);
                this.gotoAndStopFrame(occ_menu_audio.occ_muted, 1);

                this.removeListener(type_timeupdate, reference_timeupdate, this.$functions.handleTimeUpdateAudio, () => {
                    this.addListener(element, type_timeupdate, reference_timeupdate, this.$functions.handleTimeUpdateAudio, false, {
                        element: element,
                        occurrence: occurrence
                    });
                });

                this.removeListener(type_pause, reference_pause, this.$functions.handlePauseAudio, () => {
                    this.addListener(element, type_pause, reference_pause, this.$functions.handlePauseAudio, false, {
                        element: element,
                        occurrence: occurrence,
                        status: {pause: false}
                    });
                });

                element.id = occurrence;

                element.src = uri;

                element.play();
            });
        }
    };

    openVideo = () => {
        const
            {element} = this.state,
            _this_frame = this.getFrame(),
            type_timeupdate = 'timeupdate',
            reference_timeupdate = 'timeupdate-video',
            type_pause = 'pause',
            reference_pause = 'pause-video',
            type_ended = 'ended',
            reference_ended = 'ended-video',
            {occ_menu_video} = _this_frame;

        if (this.isElement(element, 'video')) {
            let listener = this.getListener(reference_pause);

            if (!this.isEmpty(listener)) {
                element.pause();

                const {data: {status}} = listener;

                if (Boolean(status.pause)) {
                    this.gotoAndStopFrame(occ_menu_video.occ_play, 2);
                    status.pause = false;
                    element.play();
                }
            } else {
                element.currentTime = 0;
                element.play();
            }

            this.gotoAndStopFrame(occ_menu_video.occ_play, 2);
            this.gotoAndStopFrame(occ_menu_video.occ_muted, 1);

            this.removeListener(type_timeupdate, reference_timeupdate, this.$functions.handleTimeUpdateVideo, () => {
                this.addListener(element, type_timeupdate, reference_timeupdate, this.$functions.handleTimeUpdateVideo, false, {
                    element: element
                });
            });

            this.removeListener(type_pause, reference_pause, this.$functions.handlePauseVideo, () => {
                this.addListener(element, type_pause, reference_pause, this.$functions.handlePauseVideo, false, {
                    element: element,
                    status: {pause: false}
                });
            });

            this.removeListener(type_ended, reference_ended, this.$functionsAnimate.handleEndVideo, () => {
                this.addListener(element, type_ended, reference_ended, this.$functionsAnimate.handleEndVideo, false, {
                    callback: () => {
                        element.currentTime = 0;
                    }
                });
            });
        }
    };

    /**
     *
     * @param uri
     */
    downloadFile = (uri) => {
        const a = document.createElement('a');

        a.setAttributeNode(document.createAttribute('download'));

        a.href = uri;

        a.click();
    };

    setMenuFiles = () => {
        const
            _this_frame = this.getFrame(),
            {data} = this.state,
            array = this.verifyField(data, 'classroom_student.year.libraries');

        this.recursiveSyncMap(array, 0, array.length, (item, next, stop, index) => {
            let
                occurrence = this.padWithLeadingZeros((index + 1), 2),
                {id, attachment: {name}} = item;

            _this_frame[`occ_title_${occurrence}`].text = name;

            this[`_handleReadAttachment${occurrence}A`] && _this_frame[`btn_menu_${occurrence}A`].off('mousedown', this[`_handleReadAttachment${occurrence}A`]);
            this[`_handleReadAttachment${occurrence}A`] = _this_frame[`btn_menu_${occurrence}A`].on('mousedown', this.$functions.handleReadFile, false, false, {_id: id});

            this[`_handleReadAttachment${occurrence}B`] && _this_frame[`btn_menu_${occurrence}B`].off('mousedown', this[`_handleReadAttachment${occurrence}B`]);
            this[`_handleReadAttachment${occurrence}B`] = _this_frame[`btn_menu_${occurrence}B`].on('mousedown', this.$functions.handleReadFile, false, false, {_id: id});

            this.addImage(_this_frame[`occ_menu_${occurrence}`], item);

            next(true);
        });
    };

    setMenuAudios = () => {
        const
            _this_frame = this.getFrame(),
            {data} = this.state,
            array = this.verifyField(data, 'classroom_student.year.libraries');

        this.recursiveSyncMap(array, 0, array.length, (item, next, stop, index) => {
            let
                occurrence = this.padWithLeadingZeros((index + 1), 2),
                {id, attachment: {name, formatted_path}} = item,
                data = {_id: id, occurrence: occurrence};

            _this_frame[`occ_title_${occurrence}`].text = name;

            this.gotoAndStopFrame(_this_frame[`occ_menu_audio_${occurrence}`].occ_play, 1);
            this.gotoAndStopFrame(_this_frame[`occ_menu_audio_${occurrence}`].occ_muted, 1);

            this[`_handleReadAudio${occurrence}A`] && _this_frame[`btn_menu_${occurrence}A`].off('mousedown', this[`_handleReadAudio${occurrence}A`]);
            this[`_handleReadAudio${occurrence}A`] = _this_frame[`btn_menu_${occurrence}A`].on('mousedown', this.$functions.handleReadAudio, false, false, data);

            this[`_handleReadAudio${occurrence}B`] && _this_frame[`btn_menu_${occurrence}B`].off('mousedown', this[`_handleReadAudio${occurrence}B`]);
            this[`_handleReadAudio${occurrence}B`] = _this_frame[`btn_menu_${occurrence}B`].on('mousedown', this.$functions.handleReadAudio, false, false, data);

            this[`_handleMutedAudio${occurrence}`] && _this_frame[`btn_menu_audio_${occurrence}`].off('mousedown', this[`_handleMutedAudio${occurrence}`]);
            this[`_handleMutedAudio${occurrence}`] = _this_frame[`btn_menu_audio_${occurrence}`].on('mousedown', this.$functions.handleMutedAudio, false, false, data);

            this.addImage(_this_frame[`occ_menu_${occurrence}`], item);

            this.getAudioMetadata(formatted_path, ({duration}) => {
                _this_frame[`occ_menu_audio_${occurrence}`].occ_time.text = `00:00 / ${this.getFormatSecondsToTime(duration)}`;
                next(true);
            });
        });
    };

    setMenuVideos = () => {
        const
            _this_frame = this.getFrame(),
            {data} = this.state,
            array = this.verifyField(data, 'classroom_student.year.libraries');

        this.recursiveSyncMap(array, 0, array.length, (item, next, stop, index) => {
            let
                occurrence = this.padWithLeadingZeros((index + 1), 2),
                {attachment: {id, name, formatted_path}} = item,
                {occ_menu} = _this_frame[`occ_menu_${occurrence}`],
                uri = `${web.uri_library_videos_player}/${id}`;

            _this_frame[`occ_title_${occurrence}`].text = name;

            this.setAction({uri: uri, occ: `menu_${occurrence}A`});
            this.setAction({uri: uri, occ: `menu_${occurrence}B`});

            this.getVideoMetadata(formatted_path, occurrence, occ_menu.nominalBounds.width, occ_menu.nominalBounds.height, ({thumbnail}) => {
                occ_menu.occ_image.addChild(thumbnail);
                next(true);
            });
        });
    };

    setMenuVideosPlayer = () => {
        const
            _this_frame = this.getFrame(),
            {data} = this.state,
            {btn_menu_play_01, btn_menu_play_02, btn_menu_audio, btn_menu_full} = _this_frame,
            library = this.verifyField(data, 'classroom_student.year.library');

        let
            {attachment: {formatted_path}} = library,
            {occ_menu_video, occ_player: {occ_movie}} = _this_frame,
            width = occ_movie.nominalBounds.width,
            height = occ_movie.nominalBounds.height;

        this.gotoAndStopFrame(occ_menu_video.occ_play, 1);
        this.gotoAndStopFrame(occ_menu_video.occ_muted, 1);

        this._handleReadVideo01 && btn_menu_play_01.off('mousedown', this._handleReadVideo01);
        this._handleReadVideo01 = btn_menu_play_01.on('mousedown', this.$functions.handleReadVideo);

        this._handleReadVideo02 && btn_menu_play_02.off('mousedown', this._handleReadVideo02);
        this._handleReadVideo02 = btn_menu_play_02.on('mousedown', this.$functions.handleReadVideo);

        this._handleMutedVideo && btn_menu_audio.off('mousedown', this._handleMutedVideo);
        this._handleMutedVideo = btn_menu_audio.on('mousedown', this.$functions.handleMutedVideo);

        this.getVideoMetadata(formatted_path, 'movie', width, height, ({thumbnail, duration}) => {
            this._handleFullScreenVideo && btn_menu_full.off('mousedown', this._handleFullScreenVideo);
            this._handleFullScreenVideo = btn_menu_full.on('mousedown', this.$functions.handleFullScreenVideo, false, false, {
                thumbnail: thumbnail,
                scaleX: thumbnail.scaleX,
                scaleY: thumbnail.scaleY
            });

            occ_menu_video.occ_time.text = `00:00 / ${this.getFormatSecondsToTime(duration)}`;
            occ_movie.occ_video.addChild(thumbnail);
        });
    };

    startFiles = () => {
        const {button_menu_files} = this.props;

        this.setNavbar();

        this.setMenuFiles();

        this.setActions(button_menu_files);
    };

    startAudios = () => {
        const {button_menu_audios} = this.props;

        this.setNavbar();

        this.setMenuAudios();

        this.setActions(button_menu_audios);
    };

    startVideos = () => {
        const {button_menu_videos} = this.props;

        this.setNavbar();

        this.setMenuVideos();

        this.setActions(button_menu_videos);
    };

    startVideosPlayer = () => {
        const {button_menu_videos_player} = this.props;

        this.setNavbar();

        this.setMenuVideosPlayer();

        this.setActions(button_menu_videos_player);
    };

    startLibrary = () => {
        const {button_menu_library} = this.props;

        this.setNavbar();

        this.setActions(button_menu_library);
    };

    initFiles = () => {
        this.gotoAndStopFrame(this.get(), 1);

        this.main.getForm(`${this.$root_uri}/${api.api_library_files}`, {}, {
            done: ({status, errors, data}) => {
                if (Boolean(status)) {
                    this.setState({...this.state, data: data}, this.startFiles);
                } else {
                    console.log(errors);
                }
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.emit('process_end', {});
            }
        });
    };

    initAudios = () => {
        this.gotoAndStopFrame(this.get(), 1);

        this.main.getForm(`${this.$root_uri}/${api.api_library_audios}`, {}, {
            done: ({status, errors, data}) => {
                if (Boolean(status)) {
                    this.setState({...this.state, data: data}, this.startAudios);
                } else {
                    console.log(errors);
                }
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.emit('process_end', {});
            }
        });
    };

    initVideos = () => {
        this.gotoAndStopFrame(this.get(), 1);

        this.main.getForm(`${this.$root_uri}/${api.api_library_videos}`, {}, {
            done: ({status, errors, data}) => {
                if (Boolean(status)) {
                    this.setState({...this.state, data: data}, this.startVideos);
                } else {
                    console.log(errors);
                }
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.emit('process_end', {});
            }
        });
    };

    initVideosPlayer = () => {
        this.gotoAndStopFrame(this.get(), 1);

        this.main.getForm(`${this.$root_uri}/${api.api_library_videos_player}/${this.getIdUri()}`, {}, {
            done: ({status, errors, data}) => {
                if (Boolean(status)) {
                    this.setState({...this.state, data: data}, this.startVideosPlayer);
                } else {
                    console.log(errors);
                }
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.emit('process_end', {});
            }
        });
    };

    initLibrary = () => {
        this.gotoAndStopFrame(this.get(), 1);

        this.main.getForm(`${this.$root_uri}/${api.api_profile}`, {}, {
            done: ({status, errors, data}) => {
                if (Boolean(status)) {
                    this.setState({...this.state, data: data}, this.startLibrary);
                } else {
                    console.log(errors);
                }
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.emit('process_end', {});
            }
        });
    };
}

/**
 *
 * @type {{}}
 */
StudentLibrary.propTypes = {
    current_name: PropTypes.string,
    button_navbar: PropTypes.array,
    button_menu_library: PropTypes.array,
    button_menu_files: PropTypes.array,
    button_menu_audios: PropTypes.array,
    button_menu_videos: PropTypes.array,
    button_menu_videos_player: PropTypes.array
};

/**
 *
 * @type {{}}
 */
StudentLibrary.defaultProps = {
    current_name: null,
    button_navbar: [
        {
            occ: 'profile',
            uri: web.uri_profile
        },
        {
            occ: 'dashboard',
            uri: web.uri_dashboard
        },
        {
            occ: 'logout',
            uri: web.uri_logout
        }
    ],
    button_menu_library: [
        {
            occ: 'back',
            uri: web.uri_dashboard
        },
        {
            occ: 'files',
            uri: web.uri_library_files,
            field: 'occ_files.occ_door'
        },
        {
            occ: 'audios',
            uri: web.uri_library_audios,
            field: 'occ_audios.occ_door'
        },
        {
            occ: 'videos',
            uri: web.uri_library_videos,
            field: 'occ_videos.occ_door'
        }
    ],
    button_menu_files: [
        {
            occ: 'back',
            uri: web.uri_library
        }
    ],
    button_menu_audios: [
        {
            occ: 'back',
            uri: web.uri_library
        }
    ],
    button_menu_videos: [
        {
            occ: 'back',
            uri: web.uri_library
        }
    ],
    button_menu_videos_player: [
        {
            occ: 'back',
            uri: web.uri_library_videos
        }
    ]
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(StudentLibrary, {className: 'StudentLibrary'});
